module.exports = __webpack_public_path__ + "img/avatar_4.5b099714.jpg";